import { createApp } from 'vue';
import CashflowCalculator from './components/CashflowCalculator.vue';
import CapitalGrowth from './components/CapitalGrowth.vue';

const el = document.getElementById('cashflow-calculator-app');
if (el) {
    createApp(CashflowCalculator, {
        uid: el.dataset.uid || '',
        linkUrl: el.dataset.linkUrl || '',
        linkText: el.dataset.linkText || '',
        linkTarget: el.dataset.linkTarget || '',
    }).mount(el);
}

const el2 = document.getElementById('capital-growth-app');
if (el2) {
    createApp(CapitalGrowth, {
        uid: el2.dataset.uid || ''
    }).mount(el2);
} 